import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import * as am4core from '@amcharts/amcharts4/core';
import * as am4charts from '@amcharts/amcharts4/charts';

@Component({
  selector: 'app-doughnut-chart',
  templateUrl: './doughnut-chart.component.html',
  styleUrls: ['./doughnut-chart.component.scss']
})
export class DoughnutChartComponent implements OnInit, OnDestroy {

  private chart!: am4charts.PieChart;
  @Input() data: { category: string; value: number }[] = [];

  ngOnInit() {
    this.createChart();
    window.addEventListener('resize', this.handleResize);
    this.handleResize(); // Call it initially to set chart properties based on the initial screen size
  }

  private createChart(): void {
    // Create chart instance
    this.chart = am4core.create('doughnutChartDiv', am4charts.PieChart);

       // Disable amCharts logo
       this.chart.logo.disabled = true;


    // Add data from input or fallback demo
    this.chart.data = (this.data && this.data.length > 0)
      ? this.data
      : [
          { category: 'Category 1', value: 0 },
          { category: 'Category 2', value: 0 }
        ];

    // Create series
    const series = this.chart.series.push(new am4charts.PieSeries());
    series.dataFields.value = 'value';
    series.dataFields.category = 'category';
    series.slices.template.tooltipText = '{category}: {value}';

    // Configure slice appearance
    series.slices.template.fillOpacity = 0.8;

    // Set inner radius for the Doughnut effect
    series.innerRadius = am4core.percent(30); // Adjust for thickness

    // Add a legend
    this.chart.legend = new am4charts.Legend();
       this.chart.legend.position = 'bottom';
  }

  private handleResize = () => {
    if (this.chart) {
      const screenWidth = window.innerWidth;

      // Adjust properties based on screen size
      if (screenWidth < 600) {
        this.chart.legend.position = 'bottom'; // Move legend to the bottom on small screens
        this.chart.legend.fontSize = 12; // Smaller font for the legend
        this.chart.radius = am4core.percent(60); // Adjust chart radius to fit smaller screens
      } else {
        this.chart.legend.position = 'bottom'; // Legend on the right for larger screens
        this.chart.legend.fontSize = 14; // Normal font size for larger screens
        this.chart.radius = am4core.percent(80); // Larger chart radius for larger screens
      }

      this.chart.invalidate(); // Trigger a redraw to apply changes
    }
  };

  ngOnDestroy() {
    if (this.chart) {
      this.chart.dispose();
    }
    window.removeEventListener('resize', this.handleResize);
  }
}




// import { Component, OnInit, OnDestroy } from '@angular/core';
// import * as am4core from '@amcharts/amcharts4/core';
// import * as am4charts from '@amcharts/amcharts4/charts';


// @Component({
//   selector: 'app-doughnut-chart',
//   templateUrl: './doughnut-chart.component.html',
//   styleUrls: ['./doughnut-chart.component.scss']
// })
// export class DoughnutChartComponent {

//   private chart!: am4charts.PieChart;

//   ngOnInit() {
//     this.createChart();
//     window.addEventListener('resize', this.handleResize);
//   }

//   private createChart(): void {
//     // Create chart instance
//     this.chart = am4core.create('doughnutChartDiv', am4charts.PieChart);

//     // Add data
//     this.chart.data = [
//       { category: 'Category 1', value: 40 },
//       { category: 'Category 2', value: 30 },
//       { category: 'Category 3', value: 20 },
//       { category: 'Category 4', value: 10 }
//     ];

//     // Create series
//     const series = this.chart.series.push(new am4charts.PieSeries());
//     series.dataFields.value = 'value';
//     series.dataFields.category = 'category';
//     series.slices.template.tooltipText = '{category}: {value}';

//     // Configure slice appearance
//     series.slices.template.fillOpacity = 0.8;

//     // Set inner radius for the Doughnut effect
//     series.innerRadius = am4core.percent(30); // Adjust for thickness

//     // Add a legend
//     this.chart.legend = new am4charts.Legend();
//     // this.chart.legend.position = 'right';
//   }

//   private handleResize = () => {
//     if (this.chart) {
//       this.chart.invalidate(); // Trigger an update of the chart
//     }
//   };

//   ngOnDestroy() {
//     if (this.chart) {
//       this.chart.dispose();
//     }
//     window.removeEventListener('resize', this.handleResize);
//   }
// }